/* POWSTORE Startseite 2027 – Verhalten (defer, ~3 KB, ohne Bibliotheken)
   Slider laufen über natives Scrollen mit Scroll-Snap; JS nur für Pfeile, Seitenzähler, Fortschrittsbalken,
   Hero-Wechsel, Video-Dialog und "Weiterlesen". Ohne JS bleibt alles wisch- und scrollbar. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Slider ---- */
  function initRail(box) {
    if (box.dataset.pwReady) return; box.dataset.pwReady = '1';
    var rail = box.querySelector('.pw-rail');
    if (!rail) return;
    var prev = box.querySelector('[data-pw-prev]'), next = box.querySelector('[data-pw-next]');
    var cur = box.querySelector('[data-pw-cur]'), tot = box.querySelector('[data-pw-tot]');
    var prog = box.querySelector('.pw-progress'), bar = prog && prog.querySelector('.pw-progress__bar');
    function metrics() {
      var items = rail.children; if (!items.length) return null;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var step = items[0].getBoundingClientRect().width + gap;
      var per = Math.max(1, Math.floor((box.clientWidth + gap + 2) / step));
      var pages = Math.max(1, Math.ceil(items.length / per));
      var max = rail.scrollWidth - rail.clientWidth;
      return { step: step, per: per, pages: pages, max: max };
    }
    function update() {
      var m = metrics(); if (!m) return;
      var x = rail.scrollLeft;
      var page = m.max <= 1 ? 1 : Math.min(m.pages, Math.round((x / m.max) * (m.pages - 1)) + 1);
      if (cur) cur.textContent = page;
      if (tot) tot.textContent = m.pages;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= m.max - 2;
      if (prog && bar) {
        prog.hidden = m.max <= 1;
        var frac = Math.min(1, rail.clientWidth / rail.scrollWidth);
        var pos = m.max > 0 ? x / m.max : 0;
        bar.style.setProperty('--pw-pw', (frac * 100) + '%');
        bar.style.setProperty('--pw-px', (pos * (1 - frac) / frac * 100) + '%');
      }
      var pager = box.querySelector('.pw-pager'); if (pager) pager.hidden = m.max <= 1;
    }
    function go(dir) {
      var m = metrics(); if (!m) return;
      rail.scrollBy({ left: dir * m.step * m.per, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev && prev.addEventListener('click', function () { go(-1); });
    next && next.addEventListener('click', function () { go(1); });
    var raf; rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- Hero ---- */
  function initHero(hero) {
    if (hero.dataset.pwReady) return; hero.dataset.pwReady = '1';
    var slides = hero.querySelectorAll('.pw-hero__slide'); if (slides.length < 2) return;
    var dots = hero.querySelectorAll('.pw-hero__dot'), i = 0, t;
    var delay = (parseInt(hero.dataset.interval, 10) || 6) * 1000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); s.inert = k !== i; });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function play() { if (reduce || hero.dataset.autoplay !== 'true') return; stop(); t = setInterval(function () { show(i + 1); }, delay); }
    function stop() { clearInterval(t); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    show(0); play();
  }

  /* ---- Video-Dialog ---- */
  function embedUrl(u) {
    var m = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
    if (m) return { type: 'iframe', src: 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1' };
    m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&dnt=1' };
    return { type: 'video', src: u };
  }
  function openVideo(btn) {
    var src = btn.getAttribute('data-pw-video'); if (!src) return;
    var e = embedUrl(src);
    var d = document.createElement('dialog'); d.className = 'pw-video';
    d.setAttribute('aria-label', btn.getAttribute('data-pw-video-title') || 'Video');
    var inner = e.type === 'iframe'
      ? '<iframe src="' + e.src + '" title="Video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'
      : '<video src="' + e.src + '" controls autoplay playsinline></video>';
    d.innerHTML = '<button type="button" class="pw-video__x" aria-label="Schließen"><svg class="pw-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg></button><div class="pw-video__frame">' + inner + '</div>';
    document.body.appendChild(d);
    var close = function () { d.close(); };
    d.querySelector('.pw-video__x').addEventListener('click', close);
    d.addEventListener('click', function (ev) { if (ev.target === d) close(); });
    d.addEventListener('close', function () { d.remove(); btn.focus(); });
    d.showModal();
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-pw-video]');
    if (b) { ev.preventDefault(); openVideo(b); }
    var s = ev.target.closest && ev.target.closest('[data-pw-seo-toggle]');
    if (s) {
      var box = s.closest('.pw-seo__box'); var open = box.classList.toggle('is-clamped') === false;
      s.setAttribute('aria-expanded', open ? 'true' : 'false');
      s.textContent = open ? s.dataset.less : s.dataset.more;
    }
  });

  function init(root) {
    (root || document).querySelectorAll('[data-pw-rail-box]').forEach(initRail);
    (root || document).querySelectorAll('[data-pw-hero]').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
